import { gql } from "@apollo/client";

export const REMOVE_TIME = gql`
  mutation removeTime($_id: String!) {
    removeTime(_id: $_id)
  }
`;
